import React from 'react';

export const GROUP_TYPES = {
  DIMENSIONS: 'Dimensions',
  DETAILS: 'Details',
  WARRANTY: 'Warranty / Certifications'
};

export const getSortedValue = ({ attributeGroupList }) => (
  (attributeGroupList.specifications || [])
    .filter((attr) => attr.specName)
    .sort((entryName, compName) => {
      const nameval1 = entryName.specName.toUpperCase();
      const nameval2 = compName.specName.toUpperCase();
      if (nameval1 < nameval2) return -1;
      if (nameval1 > nameval2) return 1;
      return 0;
    }));
